import { wobaTheme } from './woba';
import { clubeAsesTheme } from './clubeDosAses';

// Adiciona novos clientes aqui — o resto do código não muda
const themes = [clubeAsesTheme, wobaTheme];

// Empresas com auth especial que não viram tema próprio
const AUTH_OVERRIDES = {
  4157: { login: 'vald', password: 'Hom@2025' },
};

export function getTheme(empresaId) {
  //if (!empresaId) return wobaTheme;
  return themes.find(t => t.empresaId === empresaId) ?? wobaTheme;
}

export function getAuth(empresaId, theme) {
  return AUTH_OVERRIDES[empresaId] ?? theme.auth;
}
